// extracted by mini-css-extract-plugin
export var component = "UnsupportedBrowserWarning-module--component--789f3";
export var fadePop = "UnsupportedBrowserWarning-module--fade-pop--ff736";
export var growHeightIn = "UnsupportedBrowserWarning-module--grow-height-in--00be2";